export default __webpack_public_path__ + "static/media/default-user-icon.ebc1ed28.svg";